import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import MoodText from 'mood/models/mood_text';
import ExtraMobileLinkView from 'core/views/extra_mobile_link';


export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll(this, 'update', 'render');
    this.$el = $('#mood-text');
    this.date_nav = options.date_nav;
    this.smiley_view = options.smiley_view;

    this.date_nav.on('change', this.update);
    this.smiley_view.on('mood-set', this.update);

    this.update();
  },
  update: function () {
    var mood_text = new MoodText();
    mood_text.params.date = this.date_nav.formatted_date();
    mood_text.fetch({ success: this.render });
  },
  render: function (mood_text) {
    var content = mood_text.get('text');
    this.$el.html(content);
    if (mobile) {
      // If we are in the native app, make sure links open in a
      // browser window.
      _.each($('a', this.$el), function (link_el) {
        new ExtraMobileLinkView({ el: link_el });
      });
    }
    this.trigger('mood_text_changed', mood_text);
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/django-mood/mood/static/js/mood/views/mood_tip.js
// module id = 156
// module chunks = 0